<div class="container">

    <!-- Loading -->
    <div class="card" *ngIf="loading">
        <p>Loading lekhak data...</p>
    </div>

    <!-- Error -->
    <div class="card error" *ngIf="error">
        {{ error }}
    </div>

    <!-- FORM -->
    <div class="card">
        <h2>Lekhak Master</h2>

        <form [formGroup]="lekhakForm" (ngSubmit)="saveLekhak()">

            <input formControlName="name" placeholder="Lekhak Name">
            <input formControlName="mobile" placeholder="Mobile">
            <input formControlName="email" placeholder="Email">

            <input formControlName="acc_no" placeholder="Account No">
            <input formControlName="ifsc" placeholder="IFSC">
            <input formControlName="bank_name" placeholder="Bank Name">
            <input formControlName="branch" placeholder="Branch">

            <input formControlName="rate" placeholder="Rate per Lekh">

            <select formControlName="status">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>

            <button type="submit">
                {{ editMode ? 'Update' : 'Add' }} Lekhak
            </button>

            <button type="button" (click)="resetForm()">Clear</button>

        </form>
    </div>

    <!-- TABLE -->
    <div class="card" *ngIf="!loading && lekhakList.length">
        <table class="table table-bordered table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Acc No</th>
                    <th>IFSC</th>
                    <th>Rate</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let l of lekhakList; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{l.name}}</td>
                    <td>{{l.acc_no}}</td>
                    <td>{{l.ifsc}}</td>
                    <td>{{l.rate}}</td>
                    <td>{{l.status}}</td>
                    <td>
                        <button (click)="editLekhak(l)">Edit</button>
                        <button (click)="deleteLekhak(l.id)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>